import { portalJson } from '@/portal/api/client';

export interface SiteConfig {
  loginEnabled: boolean;
}

/**
 * What the lab switched on or off for the website (WebApp → Settings → Website).
 * If the call fails the login stays available: the login call itself is checked again on the server.
 */
export async function fetchSiteConfig(): Promise<SiteConfig> {
  try {
    return await portalJson<SiteConfig>('/api/site-config');
  } catch {
    return { loginEnabled: true };
  }
}
